import Collapse from "../../../layout/Collapse";
import TextInput from "../../../form/TextInput";
import React, {Fragment} from "react";
import Icon from "../../../form/Icon";
import Button from "../../../form/Button";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems} = props;
    let Tag = propsTop.tag || Collapse;
    return <div className="row form-row">
        <div className="col-md-12" style={{marginTop: "5px"}}>
            <Tag {...(Tag === Fragment ? {} : {button: <Button tag="a" color="default" className="pull-right" icon={{lib: "fa", name: "paperclip"}}>Egyéb</Button>})}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={props.componentConfig.idfield} value={props.values[props.componentConfig.idfield]} label="Kód" role="idfield"/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="label" label="Cimke" {...props.getProps("label")} value={props.getValue("label")} saveChanges={props.setFieldValue}/>
                    </div>
                </div>
            </Tag>
        </div>
    </div>;
}